// Walks up from `el` to the first opaque background and classifies it,
// so Google Pay branding can adapt to merchant-customized surfaces.
export function resolveSurfaceTone(el) {
  while (el) {
    const background = getComputedStyle(el).backgroundColor;
    if (background && background !== 'transparent') {
      const alpha = background.match(
        /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*(\d+(?:\.\d+)?)\s*\)$/
      );
      if (!alpha || parseFloat(alpha[1]) > 0) {
        return lightOrDarkColor(background);
      }
    }
    el = el.parentElement;
  }
  return 'light';
}

export function lightOrDarkColor(color) {
  let r, g, b;
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  let hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 147.5) {
    return 'light';
  } else {
    return 'dark';
  }
}